import Api from '../../Serves/net-api.js'
import Http from '../../Serves/net-http.js'
var url=Http.test;
var myDate = new Date()
var tYear = myDate.getFullYear()
const state = {
  TabkeInfo:{
    token:{name:1},
  },
  details:null,//详情数据
  imei: "",
  time:'',
  Code:'',
  Index:'',
  areaName:'',
  result:"",//登录城市数据
  Year: tYear,
  active:'/',
  flag:'',//，是否特殊市
  name:'', //特殊區域名字
  roles: [],
  info: {},
  warnSum: '',
  subSum: '',
  mapData: [],
  mapDatas: [],
  mapDatasAll: [],
  mapDatasAlls: [],
  discountData: [],
  SpanningAreaData: [],
  WarningData: [],
  toolWorkRankData: []
  /* tongzhou*/
}
const actions = {
  //请求详情接口
  async getListNjDetails({commit},params){
    const res = Api.doPost(Http.test+'/purchaseSubsidyMonitor/njDetails',params,false,(res)=>{
      commit("SET_LISTNJ_DETAILS",res.result)
    })
  },
  getAccountInfo({ commit }, param) {
    return new Promise((resolve, reject) => {
      Api.doPost(Http.test+'/account/getAccountInfo', param, false, (res) => {
        const userInfo = res.result.userInfo
        commit('Code', userInfo.areaCode)
        commit('areaName', userInfo.areaName)
        
        commit('SET_INFO', userInfo)
        if (userInfo.roleName) {
          commit('SET_ROLES', [ userInfo.roleName ])
        }
        resolve(res)
      })
    })
  }
}
const mutations = {
  kName(state, data) {
    state.kName= data
  },
  flag (state, data) {
    state.flag= data
  },
  name (state, data) {
    state.name= data
  },
  time (state, data) {
    state.time= data
  },
  Code (state, data) {
    state.Code= data
  },
  Index (state, data) {
    state.Index= data
  },
  areaName (state, data) {
    state.areaName= data
  },
  SET_RESULT(state, data) {
    state.result= data
  },
  //设置详情数据
  SET_LISTNJ_DETAILS(state,data){
    state.details = data
  },
  Year (state, data) {
    state.Year = data
  },
  active (state, data) {
    state.active = data
  },
  warnSum (state, data) {
    state.warnSum = data
  },
  subSum (state, data) {
    state.subSum = data
  },
  mapData (state, data) {
    state.mapData = data
  },
  mapDatas (state, data) {
    state.mapDatas = data
  },
  mapDatasAll (state, data) {
    state.mapDatasAll = data
  },
  mapDatasAlls (state, data) {
    state.mapDatasAlls = data
  },
  SET_INFO: (state, info) => {
    state.info = info
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  discountData (state, data) {
    state.discountData = data
  },
  SpanningAreaData (state, data) {
    state.SpanningAreaData = data
  },
  WarningData (state, data) {
    state.WarningData = data
  },
  toolWorkRankData (state, data) {
    state.toolWorkRankData = data
  }
};
const getters = {
    TabkeInfo: state => state.time,
    warnSum: state => state.warnSum,
    subSum: state => state.subSum,
    mapData: state => state.mapData,
    // roles: state => state.roles,
    userInfo: state => state.info
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/token.js